import { render, staticRenderFns } from "./PolestarProjectCopy.vue?vue&type=template&id=6baaf716&"
import script from "./PolestarProjectCopy.vue?vue&type=script&lang=js&"
export * from "./PolestarProjectCopy.vue?vue&type=script&lang=js&"
import style0 from "./PolestarProjectCopy.vue?vue&type=style&index=0&id=6baaf716&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports